import React  from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import JobApplicationForm from "./components/JobApplicationForm";
import { ArrowLeft, Sparkles } from "lucide-react";
import { Card } from "antd";
import JobFileAttachment from "./components/JobFileAttachment";

const EditJobPost = () => {
  const { postId } = useParams();
  const jobId = Number(postId);

  const navigate = useNavigate();
  const { state } = useLocation();

  const jobData = state?.jobData || [];
  const job = jobData.find((j) => j.jpo_id === jobId);

  if (!job) {
    return <div className="p-8 text-gray-600">Job not found.</div>;
  }


	return (
		<div className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 space-y-5">
		<button
			onClick={() => navigate(`/job-posts/${postId}/view`)}
          	className="inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium 
                     focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] 
                     h-9 px-4 py-2 hover:bg-purple-50 border border-purple-200 bg-white"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to job details
        </button>
			<div className="gradient-effect relative">
				<div className="card-shadow"/>
				<Card 
					key={jobId}
					className="rounded-xl flex relative border-2 border-purple-100">
					<div className="gap-2 flex">
						<div className="w-10 h-10 icon-effect dark">
							<Sparkles className="w-5 h-5"/>
						</div>
						<div className="space-y-8 flex-1 items-center">
							<h1 className="text-gray-900 text-2xl font-medium ">
               					Apply for {job.jpo_title}
							</h1>
							<p className="text-gray-800 text-base">{job.department_name} • {job.jpo_location}</p>
						</div>
					</div>
				</Card>
			</div>

			<JobApplicationForm recordId={jobId} mode="edit"/>
			<JobFileAttachment/>

			<div className="flex flex-col sm:flex-row sm:items-center gap-4">
				<button
				 	onClick={() => navigate(`/job-posts/${postId}/view`)}
					type="button"
					className="w-full sm:w-auto h-9 px-4 py-2 text-sm font-medium rounded-md 
						border-2 border-purple-200 hover:border-purple-300 hover:bg-purple-50
						transition-all"
				>
					Cancel
				</button>

				<button
					type="submit"
					className="w-full sm:w-auto h-9 px-4 py-2 text-sm font-medium rounded-md
						bg-gradient-to-r from-purple-600 to-emerald-600 transition-all
						hover:from-purple-700 hover:to-emerald-700 text-white shadow-lg 
						focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2"
				>
					Submit Application
				</button>
			</div>

		</div>
    );
};

export default EditJobPost;